import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var IsObjectPipe = (function () {
    function IsObjectPipe() {
    }
    IsObjectPipe.prototype.transform = function (input) {
        return isObject(input);
    };
    return IsObjectPipe;
}());
export { IsObjectPipe };
IsObjectPipe.decorators = [
    { type: Pipe, args: [{ name: 'isObject' },] },
];
/** @nocollapse */
IsObjectPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-object.js
// module id = 231
// module chunks = 4